// Needs types and tests
import React from 'react';

import AcademyIndexPage from '../../../components/academy/indexPage/AcademyIndexPage';

import { AcademyPageProps } from '../../../types/pages/academy/academy';

import { assetTypeFacetKey } from '../../../constants/academy';

const TutorialsPage: React.FC<AcademyPageProps> = () => {
  const initialFilters = {
    [assetTypeFacetKey]: ['Tutorial'],
  };
  return <AcademyIndexPage initialFilters={initialFilters}/>;
};

export default TutorialsPage;
